(() => {
  'use strict';

  if (customElements.get('book-service-drawer')) return;

  class BookServiceDrawer extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('.book-service__drawer');
      this.overlay = this.querySelector('.book-service__overlay');
      this.openButton = this.querySelector('[data-book-service-open]');
      this.closeButtons = this.querySelectorAll('[data-book-service-close]');
      this.previouslyFocused = null;

      this.openButton?.addEventListener('click', () => this.open());
      this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.drawer?.hidden) this.close();
      });

      if (this.dataset.openOnLoad === 'true') this.open();
    }

    open() {
      if (!this.drawer || !this.overlay) return;
      this.previouslyFocused = document.activeElement;
      this.drawer.hidden = false;
      this.overlay.hidden = false;
      this.openButton?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('book-service-open');
      this.drawer.querySelector('input, select, textarea, button')?.focus();
    }

    close() {
      if (!this.drawer || !this.overlay) return;
      this.drawer.hidden = true;
      this.overlay.hidden = true;
      this.openButton?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('book-service-open');
      this.previouslyFocused?.focus?.();
    }
  }

  customElements.define('book-service-drawer', BookServiceDrawer);
})();
